export class ItemViewModel {
    constructor(id?: number, name?: string) {
        this.Id = id;
        this.Name = name;
    }
    public Id: number;
    public Name: string;
}
export class StringItemViewModel{
    constructor(id?: string, name?: string) {
        this.Id = id;
        this.Name = name;
    }
    public Id: string;
    public Name: string; 
}
export class WareHouseViewModel{
    public FK_WareHouse_Id:ItemViewModel;
}

export class WareHouseModel{
    public wareHouse:ItemViewModel1;
}

export class ItemViewModel1 {
    constructor(id?: number, name?: string, code?: string) {
        this.id = id;
        this.name = name;
        this.code = code;
    }
    public code?: string = "";
    public id: number;
    public name: string;
}

export class ItemCodeModel {
    constructor(id?: number, name?: string, codes?: string) {
        this.id = id;
        this.name = name;
        this.codes = codes;
    }
    public codes?: string = "";
    public id: number;
    public name: string;
}